const selectStyles = {
  alignItems: 'center',
  border: '1px solid',
  borderColor: 'inputDefault',
  borderRadius: 'radiusDefault',
  color: 'textPrimary',
  display: 'flex',
  fontFamily: 'normal',
  fontSize: {
    base: 'fontSize30',
    md: 'fontSize20'
  },
  justifyContent: 'space-between',
  height: '40px',
  outline: 'none',
  pl: 'space50',
  position: 'relative',
  // needs follow up
  pr: '40px',
  // needs follow up
  py: '9px',
  transition: 'fast',
  transitionProperty: 'box-shadow',
  width: '100%',
  _hover: {
    borderColor: 'inputHover'
  }
};
const selectPopoverStyles = {
  backgroundColor: 'white',
  border: '1px solid',
  borderColor: 'carbon100',
  borderRadius: 'radiusDefault',
  boxShadow: 'medium',
  outline: 'none',
  py: 'space30'
};

export { selectPopoverStyles, selectStyles };
